export default "__VITE_ASSET__7379699c__"